/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --border-bottom: var(--nve-ref-border-width-sm) solid var(--nve-ref-border-color);
  --padding: var(--nve-ref-size-400);
  display: block;
  width: 100%;
}

[internal-host] {
  border-bottom: var(--border-bottom);
  padding: var(--padding);
  color: var(--color);
}
